/**
 * ad_conversions_controller.js — fires server-queued ad conversions once (Stimulus).
 *
 * Mounted by templates/components/ad_conversions.html, which renders only when
 * application/services/ad_conversions.py queued conversions (a real sign-up, a
 * paid Stripe Checkout). The server already consumed the queue, so this element
 * is the only copy: connect() sends each conversion, then removes the element
 * before Turbo can snapshot it, so a back-navigation restore never fires the
 * same conversion twice.
 *
 * Each conversion carries a `gtag` event for the Google tag loaded in the
 * layout head, and for Australian traffic a `meta` event (a Lead has only the
 * `meta` event). The Pixel event is sent straight away rather than deferred like
 * the PageView, and carries the same eventID the server sent to the Conversions
 * API, which is how Meta counts the pair once.
 *
 * When a tag is blocked by the browser its events are dropped; the Conversions
 * API copy still reaches Meta.
 */
import { Controller } from "@hotwired/stimulus";
import { metaPixel } from "./_meta_pixel.js";

export default class extends Controller {
    static values = { events: Array, metaPixelId: String };

    connect() {
        this.eventsValue.forEach(({ gtag, meta }) => {
            if (gtag) this._sendGtag(gtag);
            if (meta && this.metaPixelIdValue) this._sendMeta(meta);
        });
        this.element.remove();
    }

    _sendGtag({ name, params }) {
        if (typeof window.gtag === "function") window.gtag("event", name, params);
    }

    _sendMeta({ name, event_id, params }) {
        metaPixel(this.metaPixelIdValue)("track", name, params, { eventID: event_id });
    }
}
